var map = {
	"./okumidori-b.jpg": "02cf",
	"./okumidori-h.jpg": "8676",
	"./saemidori-h.jpg": "16f4",
	"./yabukita-b.jpg": "365a",
	"./yabukita-h.jpg": "f3a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abf9";